/* React Imports */
import React, { useContext, useEffect, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useLocation, useNavigate } from 'react-router-v6';

/* Styling Imports */
import { Menu } from 'antd';
import { SpreadsheetsIcon } from '../assets/icons';

/* API Services */
import AuthService from 'api-services/auth-service';
import ChatBotContext from 'hooks/chat-bot-context';
import { DEFAULT_DRAWER_ITEMS } from 'layout/side-menu-items';
import useDecodeToken from 'hooks/use-decode-token';
import { FREE_PLAN_LOOKUP } from 'utilities/constants';

import Logo from 'assets/img/logo.png';

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { planId, role } = useDecodeToken();

  const { selectedBot, botName } = useContext(ChatBotContext);
  const [ selectedKey, setSelectedKey ] = useState('mychatbots');
  const [ openKey, setOpenKey ] = useState([]);

  /* Component State */
  const [drawerItems, setDrawerItems] = useState(DEFAULT_DRAWER_ITEMS);

  /* Navbar functionality */
  const onMenuClick = ({ key, item }) => {
    const { route } = item.props; //getting key pressed
    if (key === 'logout') { //handling logout
      AuthService.logout(); 
      navigate('/login');
      return;
    }

    navigate(route); 
  };

  /* Use Effects */
  useEffect(() => {
    if(drawerItems) {
      if(selectedBot) {
        const newDrawerItems = [...DEFAULT_DRAWER_ITEMS];

        if(role && role === 1) {
          const reports ={
            key: 'reports',
            icon: <SpreadsheetsIcon/>,
            label: 'Reports',
            route: '/reports',
          };
          newDrawerItems.unshift(reports);
        }
       
        const myChatbotItem = newDrawerItems.find((item) => item.key === 'my-chatbot');
        myChatbotItem.label = botName;

        setDrawerItems(newDrawerItems);
      } else {
        const newDrawerItems = [...DEFAULT_DRAWER_ITEMS];
        
        if(role && role === 1) {
          const reports ={
            key: 'reports',
            icon: <SpreadsheetsIcon/>,
            label: 'Reports',
            route: '/reports',
          };
          newDrawerItems.unshift(reports);
        }
        setDrawerItems(newDrawerItems.filter((item) => item.key !== 'my-chatbot'));
      }
    }
  }, [selectedBot, botName]);

  useEffect(() => {
    if(drawerItems) {
      const newDrawerItems = [...DEFAULT_DRAWER_ITEMS];
      const myAccount = newDrawerItems.find((item) => item.key === 'my-account');

      if(planId === FREE_PLAN_LOOKUP) { 
        myAccount.label = 'My Account (Free Plan)';
      } else {
        myAccount.label = 'My Account';
      }
      
      if(role && role === 1) {
        const reports ={
          key: 'reports',
          icon: <SpreadsheetsIcon/>,
          label: 'Reports',
          route: '/reports',
        };
        newDrawerItems.unshift(reports);
      }
      
      if(selectedBot) {
        setDrawerItems(newDrawerItems);
      } else {
        setDrawerItems(newDrawerItems.filter((item) => item.key !== 'my-chatbot'));
      }
    }
  }, [planId]);

  useEffect(() => {
    let selKey = 'mychatbots';
    drawerItems.forEach(d => {
      if(d.route === location.pathname) {
        selKey = d.key;
        setOpenKey([]);
      }

      if(d.children) {
        d.children.forEach(c => {
          if(c.route === location.pathname) {
            selKey = c.key;
            setOpenKey([d.key]);
          }
        });
      }
    });

    setSelectedKey(selKey);
  }, [location.pathname, drawerItems]);

  /* UI */
  return (
    <>
      <div className="logo-container">
        <a href='/' target='_blank' title='Chat Buddy Pro'>
          <img src={Logo} alt='Chat Buddy Pro' />
          {/* <Folio3Logo /> */}
        </a>
      </div>

      <PerfectScrollbar>
        <Menu
          defaultSelectedKeys={[selectedKey]}
          selectedKeys={[selectedKey]}
          defaultOpenKeys={openKey}
          openKeys={openKey}
          onClick={(e) => onMenuClick(e)}
          onOpenChange={(newOpenKeys) => {
            setOpenKey(newOpenKeys);
          }}
          mode="inline"
          items={drawerItems}
        />
      </PerfectScrollbar>
    </>
  );
};
export default App;
